import { c as _c } from "react/compiler-runtime";
import ButtonCall from '@components/button-call/ButtonCall';
import SVGelem from '@components/SVGelem/SVGelem';
import Wrapper from '@components/wrapper/Wrapper';
import formaLogo from '@images/renders/icon_images/forma.svg';
import ROUTES from '@lib/constants/routes';
import { useDeviceScreen } from '@lib/layouts/DeviceScreenProvider';
import { handleChangeFormName, handleOpenModelForm, handleScrollVisible, handleVisibleHeader } from '@lib/store/slices/ComponentsSlice';
import { developersSelector, footerLeftSelector, footerMiddleSelector, footerRightSelector } from '@lib/store/slices/ProjectSlice';
import { CONTACTS, SCHEMA, URLS } from '@lib/tools/helpers/constants';
import { ScrollSmoother } from 'gsap/ScrollSmoother';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import Svg from 'react-inlinesvg';
import { useDispatch, useSelector } from 'react-redux';
import style from './Footer.module.scss';
function Footer() {
  const $ = _c(61);
  const dispatch = useDispatch();
  const pathname = usePathname();
  const {
    isMobile
  } = useDeviceScreen();
  const footerLeft = useSelector(footerLeftSelector);
  const footerMiddle = useSelector(footerMiddleSelector);
  const footerRight = useSelector(footerRightSelector);
  const developers = useSelector(developersSelector);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = new Date().getFullYear();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const year = t0;
  let t1;
  if ($[1] !== dispatch || $[2] !== isMobile || $[3] !== pathname) {
    t1 = () => {
      const smoother = ScrollSmoother.get();
      if (isMobile && pathname === ROUTES.root) {
        dispatch(handleScrollVisible(true));
        window.scrollTo(0, 0);
        setTimeout(() => {
          dispatch(handleScrollVisible(false));
          dispatch(handleVisibleHeader(true));
        }, 500);
      } else {
        if (!isMobile && pathname === ROUTES.root) {
          dispatch(handleScrollVisible(true));
          if (smoother) {
            smoother.scrollTo(0, {
              duration: 0
            });
          }
          setTimeout(() => {
            dispatch(handleScrollVisible(false));
            dispatch(handleVisibleHeader(true));
          }, 500);
        } else {
          setTimeout(() => {
            dispatch(handleVisibleHeader(true));
          }, 500);
        }
      }
    };
    $[1] = dispatch;
    $[2] = isMobile;
    $[3] = pathname;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const handleScrollLogo = t1;
  let t2;
  if ($[5] !== developers) {
    t2 = developers?.map(_temp);
    $[5] = developers;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t2) {
    t3 = <>{t2}</>;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const Developers = t3;
  const t4 = pathname === ROUTES.root ? style.footerContainer__landing : style.footerContainer;
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = new Date().getFullYear();
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <meta content={String(t5)} itemProp="copyrightYear" />;
    t7 = <meta content={"\u041E\u041E\u041E \xAB\u0424\u043E\u0440\u043C\u0430\xBB"} itemProp="copyrightHolder" />;
    $[10] = t6;
    $[11] = t7;
  } else {
    t6 = $[10];
    t7 = $[11];
  }
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <SVGelem className={style.svgClass} href="#moments_white" />;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== handleScrollLogo) {
    t9 = <Link href={ROUTES.root} className={style.footerLogo} onClick={handleScrollLogo} aria-label={"\u041C\u043E\u043C\u0435\u043D\u0442\u0441 \u2013 \u0436\u0438\u043B\u043E\u0439 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0441 \u0431\u0438\u0437\u043D\u0435\u0441-\u043A\u043B\u0430\u0441\u0441\u0430 \u043E\u0442 Forma"}>{t8}</Link>;
    $[13] = handleScrollLogo;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== isMobile) {
    t10 = !isMobile && <a className={style.formaLogoBox} target="_blanc" href="https://forma.ru/"><span>Проект застройщика</span><Svg className={style.formaLogo} src={formaLogo.src} /></a>;
    $[15] = isMobile;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== footerLeft?.menuItems || $[18] !== footerRight?.menuItems || $[19] !== isMobile) {
    t11 = isMobile && <div className={style.footerNavMenu} itemScope={true} itemType={SCHEMA.SITE_NAVIGATION_ELEMENT}><div className={style.footerNavMenu__box}>{footerLeft?.menuItems?.map(_temp2)}</div><div className={style.footerNavMenu__box}>{footerRight?.menuItems?.map(_temp3)}</div></div>;
    $[17] = footerLeft?.menuItems;
    $[18] = footerRight?.menuItems;
    $[19] = isMobile;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== dispatch || $[22] !== isMobile) {
    t12 = isMobile && <ButtonCall className={style.footerWhite__button} handleFuction={() => {
      dispatch(handleOpenModelForm(true));
      dispatch(handleChangeFormName("callbackForm"));
    }} text={"\u0417\u0430\u043A\u0430\u0437\u0430\u0442\u044C \u0437\u0432\u043E\u043D\u043E\u043A"} />;
    $[21] = dispatch;
    $[22] = isMobile;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t10 || $[25] !== t11 || $[26] !== t12 || $[27] !== t9) {
    t13 = <div className={style.footerLeft}>{t9}{t10}{t11}{t12}</div>;
    $[24] = t10;
    $[25] = t11;
    $[26] = t12;
    $[27] = t9;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== dispatch || $[30] !== footerLeft || $[31] !== footerMiddle || $[32] !== footerRight || $[33] !== isMobile) {
    t14 = !isMobile && footerLeft && footerMiddle && footerRight && <div className={style.footerRight}><div className={style.footerNavMenu} itemScope={true} itemType={SCHEMA.SITE_NAVIGATION_ELEMENT}><div className={style.footerNavMenu__box}>{footerLeft?.menuItems?.map(_temp4)}</div><div className={style.footerNavMenu__box}>{footerMiddle?.menuItems?.map(_temp5)}</div><div className={style.footerNavMenu__box}>{footerRight?.menuItems?.map(_temp6)}</div></div><ButtonCall className={style.footerWhite__button} handleFuction={() => {
        dispatch(handleOpenModelForm(true));
        dispatch(handleChangeFormName("callbackForm"));
      }} text={"\u0417\u0430\u043A\u0430\u0437\u0430\u0442\u044C \u0437\u0432\u043E\u043D\u043E\u043A"} /></div>;
    $[29] = dispatch;
    $[30] = footerLeft;
    $[31] = footerMiddle;
    $[32] = footerRight;
    $[33] = isMobile;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== t13 || $[36] !== t14) {
    t15 = <div className={style.footerWrapper}>{t13}{t14}</div>;
    $[35] = t13;
    $[36] = t14;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  let t16;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <hr className={style.footerHr} />;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  let t17;
  if ($[39] !== Developers || $[40] !== isMobile) {
    t17 = !isMobile && <div className={style.footerSubText__left}><p className={style.footerSubTextPreLink}>Проектная декларация  <a className={style.footerSubTextLink} target="_blank" href={"https://\u043D\u0430\u0448.\u0434\u043E\u043C.\u0440\u0444/\u0441\u0435\u0440\u0432\u0438\u0441\u044B/\u043A\u0430\u0442\u0430\u043B\u043E\u0433-\u043D\u043E\u0432\u043E\u0441\u0442\u0440\u043E\u0435\u043A/\u043E\u0431\u044A\u0435\u043A\u0442/51053"} rel="noreferrer">1 очередь</a>, <a className={style.footerSubTextLink} target="_blank" href={"https://\u043D\u0430\u0448.\u0434\u043E\u043C.\u0440\u0444/\u0441\u0435\u0440\u0432\u0438\u0441\u044B/\u043A\u0430\u0442\u0430\u043B\u043E\u0433-\u043D\u043E\u0432\u043E\u0441\u0442\u0440\u043E\u0435\u043A/\u043E\u0431\u044A\u0435\u043A\u0442/53988"} rel="noreferrer">2 очередь</a>  на сайте  <a className={style.footerSubTextLink} target="_blank" href={"https://\u043D\u0430\u0448.\u0434\u043E\u043C.\u0440\u0444/\u0441\u0435\u0440\u0432\u0438\u0441\u044B/\u043A\u0430\u0442\u0430\u043B\u043E\u0433-\u043D\u043E\u0432\u043E\u0441\u0442\u0440\u043E\u0435\u043A/\u043E\u0431\u044A\u0435\u043A\u0442/51053"} rel="noreferrer">наш.дом.рф</a></p><div className={style.footerSecondSub}>{Developers}<Link className={style.footerSubTextLink} href={ROUTES.map}>Карта сайта</Link><Link className={style.footerSubTextLink} href={ROUTES.privacy}>Пользовательское соглашение</Link><a className={style.footerSubTextLink} target="_blanc" href={URLS.YANDEX_SMARTCAPTCHA_NOTICE}>Условия обработки данных Яндекс</a><Link className={style.footerSubTextLink} href={ROUTES.operatorPolicy}>Политика Оператора в отношении обработки персональных данных</Link></div></div>;
    $[39] = Developers;
    $[40] = isMobile;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  let t18;
  if ($[42] !== Developers || $[43] !== isMobile) {
    t18 = isMobile && <div className={style.footerSubText__left}><div className={style.footerSecondSub}>{Developers}<Link className={style.footerSubTextLink} href={ROUTES.privacy}>Пользовательское соглашение</Link><Link className={style.footerSubTextLink} href={ROUTES.map}>Карта сайта</Link><a className={style.footerSubTextLink} target="_blanc" href={URLS.YANDEX_SMARTCAPTCHA_NOTICE}>Условия обработки данных Яндекс</a><Link className={style.footerSubTextLink} href={ROUTES.operatorPolicy}>Политика Оператора в отношении обработки персональных данных</Link></div><p className={style.footerSubTextPreLink}>Проектная декларация <a className={style.footerSubTextLink} target="_blank" href={"https://\u043D\u0430\u0448.\u0434\u043E\u043C.\u0440\u0444/\u0441\u0435\u0440\u0432\u0438\u0441\u044B/\u043A\u0430\u0442\u0430\u043B\u043E\u0433-\u043D\u043E\u0432\u043E\u0441\u0442\u0440\u043E\u0435\u043A/\u043E\u0431\u044A\u0435\u043A\u0442/51053"} rel="noreferrer">1 очередь</a>, <a className={style.footerSubTextLink} target="_blank" href={"https://\u043D\u0430\u0448.\u0434\u043E\u043C.\u0440\u0444/\u0441\u0435\u0440\u0432\u0438\u0441\u044B/\u043A\u0430\u0442\u0430\u043B\u043E\u0433-\u043D\u043E\u0432\u043E\u0441\u0442\u0440\u043E\u0435\u043A/\u043E\u0431\u044A\u0435\u043A\u0442/53988"} rel="noreferrer">2 очередь</a><br />на сайте <a className={style.footerSubTextLink} target="_blank" href={"https://\u043D\u0430\u0448.\u0434\u043E\u043C.\u0440\u0444/\u0441\u0435\u0440\u0432\u0438\u0441\u044B/\u043A\u0430\u0442\u0430\u043B\u043E\u0433-\u043D\u043E\u0432\u043E\u0441\u0442\u0440\u043E\u0435\u043A/\u043E\u0431\u044A\u0435\u043A\u0442/51053"} rel="noreferrer">наш.дом.рф</a></p></div>;
    $[42] = Developers;
    $[43] = isMobile;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  let t19;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <div className={style.footerSubText__links}><a className={style.footerSubText__link} href={"mailto:" + CONTACTS.MAIL}>{CONTACTS.MAIL}</a><Link suppressHydrationWarning={true} className={style.footerSubText__link} href={"tel:" + CONTACTS.PHONE}>{CONTACTS.PHONE}</Link></div>;
    $[45] = t19;
  } else {
    t19 = $[45];
  }
  let t20;
  if ($[46] !== isMobile) {
    t20 = isMobile && <a className={style.formaLogoBox} target="_blanc" href="https://forma.ru/"><span>Проект застройщика</span><Svg className={style.formaLogo} src={formaLogo.src} /></a>;
    $[46] = isMobile;
    $[47] = t20;
  } else {
    t20 = $[47];
  }
  let t21;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <div className={`${style.footerSubTextLink} ${style.footerSubTextLink__notline}`}>© 2022{year > 2022 && <span>–{year}</span>} ООО «ФОРМА»</div>;
    $[48] = t21;
  } else {
    t21 = $[48];
  }
  let t22;
  if ($[49] !== t20) {
    t22 = <div className={style.footerSubText__right}>{t19}{t20}{t21}</div>;
    $[49] = t20;
    $[50] = t22;
  } else {
    t22 = $[50];
  }
  let t23;
  if ($[51] !== t17 || $[52] !== t18 || $[53] !== t22) {
    t23 = <div className={style.footerSubText}>{t17}{t18}{t22}</div>;
    $[51] = t17;
    $[52] = t18;
    $[53] = t22;
    $[54] = t23;
  } else {
    t23 = $[54];
  }
  let t24;
  if ($[55] !== t15 || $[56] !== t23) {
    t24 = <Wrapper>{t15}{t16}{t23}</Wrapper>;
    $[55] = t15;
    $[56] = t23;
    $[57] = t24;
  } else {
    t24 = $[57];
  }
  let t25;
  if ($[58] !== t24 || $[59] !== t4) {
    t25 = <div id="footer" className={t4} itemScope={true} itemType={SCHEMA.WP_FOOTER}>{t6}{t7}{t24}</div>;
    $[58] = t24;
    $[59] = t4;
    $[60] = t25;
  } else {
    t25 = $[60];
  }
  return t25;
}
function _temp6(el_3) {
  if (el_3?.path.includes("contest")) {
    return <a key={el_3.path} className={style.footerNavItem} href={el_3?.path} itemProp="url"><span itemProp="name">{el_3?.value}</span></a>;
  }
  return <Link key={el_3.path} className={style.footerNavItem} href={el_3?.path} itemProp="url"><span itemProp="name">{el_3?.value}</span></Link>;
}
function _temp5(el_2) {
  if (el_2?.path.includes("contest")) {
    return <a key={el_2.path} className={style.footerNavItem} href={el_2?.path} itemProp="url"><span itemProp="name">{el_2?.value}</span></a>;
  }
  return <Link key={el_2.path} className={style.footerNavItem} href={el_2?.path} itemProp="url"><span itemProp="name">{el_2?.value}</span></Link>;
}
function _temp4(el_1) {
  if (el_1?.path.includes("contest")) {
    return <a key={el_1?.path} className={style.footerNavItem} href={el_1?.path} itemProp="url"><span itemProp="name">{el_1?.value}</span></a>;
  }
  return <Link key={el_1?.path} className={style.footerNavItem} href={el_1?.path} itemProp="url"><span itemProp="name">{el_1?.value}</span></Link>;
}
function _temp3(el_0) {
  if (el_0?.path.includes("contest")) {
    return <a key={el_0?.path} className={style.footerNavItem} href={el_0?.path} itemProp="url"><span itemProp="name">{el_0?.value}</span></a>;
  }
  return <Link key={el_0?.path} className={style.footerNavItem} href={el_0?.path} itemProp="url"><span itemProp="name">{el_0?.value}</span></Link>;
}
function _temp2(el) {
  if (el.path.includes("contest")) {
    return <a key={el?.path} className={style.footerNavItem} href={el?.path} itemProp="url"><span itemProp="name">{el?.value}</span></a>;
  }
  return <Link key={el?.path} className={style.footerNavItem} href={el?.path} itemProp="url"><span itemProp="name">{el?.value}</span></Link>;
}
function _temp(developer) {
  return developer?.name && developer?.value ? <a key={developer.id ?? developer.value} className={style.footerSubTextLink} href={developer.value} target="_blank" rel="noreferrer">{developer.name}</a> : null;
}
export default Footer;